import NewProjectLayout from "pages/project/NewProjectLayout";
import { ProjectTypes } from "service/projects";

const DcaTypeCurveCreateProject = () => {
  return (
    <NewProjectLayout
      input={{
        project_type: ProjectTypes[1].value,
        project_name: "",
        comment: "",
        redirect: "/project_summary/",
      }}
    />
  );
};
export default DcaTypeCurveCreateProject;